<template>
    <div class="container">
        <section class="">
            <div class="path">
                <span class="title">港口</span>
                <div class="">
                    <i class="el-icon-refresh" @click="getList(1,1)"></i>
                    <el-button type="danger" @click="centerDialogVisible=!centerDialogVisible;type=2;which=1;typeName='港口'" size="mini">新增</el-button>
                </div>
            </div>
            <div class="table_path">
                <el-table :data="brandList" style="width: 100%" height="100%" size="mini" header-cell-class-name="list_table_th text-center">
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div class="icon_wrap">
                                <!-- <i class="operation_edit" @click="edit(scope.row.id,1)" title="修改"></i> -->
                                <i class="operation_delete" @click="del(scope.row.id,1)" title="删除"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="港口" prop="name" show-overflow-tooltip></el-table-column>
                    <el-table-column label="状态">
                         <template slot-scope="scope">
                            <div :class="scope.row.status==1?'setBaseBtnStatus':'setBaseBtnStatusProhibit'" @click="changeStatus(scope.row.id,1,scope.row.status)">{{scope.row.status_label}}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </section>
        <section>
            <div class="path">
                <span class="title">付款方式</span>
                <div class="">
                    <i class="el-icon-refresh" @click="getList(2,1)"></i>
                    <el-button type="danger" @click="centerDialogVisible=!centerDialogVisible;type=2;which=2;typeName='付款方式'" size="mini">新增</el-button>
                </div>
            </div>
            <div class="table_path">
                <el-table :data="breedList" style="width: 100%" height="100%" size="mini" header-cell-class-name="list_table_th text-center">
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div class="icon_wrap">
                                <!-- <i class="operation_edit" @click="edit(scope.row.id,2)" title="修改"></i> -->
                                <i class="operation_delete" @click="del(scope.row.id,2)" title="删除"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="付款方式" prop="name" show-overflow-tooltip></el-table-column>
                    <el-table-column label="状态">
                         <template slot-scope="scope">
                            <div :class="scope.row.status==1?'setBaseBtnStatus':'setBaseBtnStatusProhibit'" @click="changeStatus(scope.row.id,2,scope.row.status)">{{scope.row.status_label}}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </section>
        <section>
            <div class="path">
                <span class="title">费用名称</span>
                <div class="">
                    <i class="el-icon-refresh" @click="getList(3,1)"></i>
                    <el-button type="danger" @click="centerDialogVisible=!centerDialogVisible;type=2;which=3;typeName='费用名称'" size="mini">新增</el-button>
                </div>
            </div>
            <div class="table_path">
                <el-table :data="gradeList" style="width: 100%" height="100%" size="mini" header-cell-class-name="list_table_th text-center">
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div class="icon_wrap">
                                <!-- <i class="operation_edit" @click="edit(scope.row.id,3)" title="修改"></i> -->
                                <i class="operation_delete" @click="del(scope.row.id,3)" title="删除"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="费用名称" prop="name" show-overflow-tooltip></el-table-column>
                    <el-table-column label="费用类型" prop="types_label" show-overflow-tooltip></el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <div :class="scope.row.status==1?'setBaseBtnStatus':'setBaseBtnStatusProhibit'" @click="changeStatus(scope.row.id,3,scope.row.status)">{{scope.row.status_label}}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </section>
        <section>
            <div class="path">
                <span class="title">仓库</span>
                <div class="">
                    <i class="el-icon-refresh" @click="getList(4,1)"></i>
                    <el-button type="danger" @click="centerDialogVisible=!centerDialogVisible;type=2;which=4;typeName='仓库';" size="mini">新增</el-button>
                </div>
            </div>
            <div class="table_path">
                <el-table :data="warehouseList" style="width: 100%" height="100%" size="mini" header-cell-class-name="list_table_th text-center">
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div class="icon_wrap">
                                <i class="operation_edit" @click="edit(scope.row.id,4)" title="修改"></i>
                                <i class="operation_delete" @click="del(scope.row.id,4)" title="删除"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="仓库" prop="name" show-overflow-tooltip></el-table-column>
                    <el-table-column label="所属区域" prop="area_name" show-overflow-tooltip></el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <div :class="scope.row.status==1?'setBaseBtnStatus':'setBaseBtnStatusProhibit'" @click="changeStatus(scope.row.id,4,scope.row.status)">{{scope.row.status_label}}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </section>
        <section>
            <div class="path">
                <span class="title">库位</span>
                <div class="">
                    <i class="el-icon-refresh" @click="getList(10,1)"></i>
                    <el-button type="danger" @click="centerDialogVisible=!centerDialogVisible;type=2;which=10;typeName='库位'" size="mini">新增</el-button>
                </div>
            </div>
            <div class="table_path">
                <el-table :data="location" style="width: 100%" height="100%" size="mini" header-cell-class-name="list_table_th text-center">
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div class="icon_wrap">
                                <!-- <i class="operation_edit" @click="edit(scope.row.id,10)" title="修改"></i> -->
                                <i class="operation_delete" @click="del(scope.row.id,10)" title="删除"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="仓库" prop="name" show-overflow-tooltip></el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <div :class="scope.row.status==1?'setBaseBtnStatus':'setBaseBtnStatusProhibit'" @click="changeStatus(scope.row.id,10,scope.row.status)">{{scope.row.status_label}}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </section>
        <section>
            <div class="path">
                <span class="title">客户属性</span>
                <div class="">
                    <i class="el-icon-refresh" @click="getList(5,1)"></i>
                    <el-button type="danger" @click="centerDialogVisible=!centerDialogVisible;type=2;which=5;typeName='客户属性'" size="mini">新增</el-button>
                </div>
            </div>
            <div class="table_path">
                <el-table :data="attributeList" style="width: 100%" height="100%" size="mini" header-cell-class-name="list_table_th text-center">
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div class="icon_wrap">
                                <!-- <i class="operation_edit" @click="edit(scope.row.id,5)" title="修改"></i> -->
                                <i class="operation_delete" @click="del(scope.row.id,5)" title="删除"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="客户属性" prop="name" show-overflow-tooltip></el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <div :class="scope.row.status==1?'setBaseBtnStatus':'setBaseBtnStatusProhibit'" @click="changeStatus(scope.row.id,5,scope.row.status)">{{scope.row.status_label}}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </section>
        <section>
            <div class="path">
                <span class="title">客户来源</span>
                <div class="">
                    <i class="el-icon-refresh" @click="getList(6,1)"></i>
                    <el-button type="danger" @click="centerDialogVisible=!centerDialogVisible;type=2;which=6;typeName='客户来源'" size="mini">新增</el-button>
                </div>
            </div>
            <div class="table_path">
                <el-table :data="sourceList" style="width: 100%" height="100%" size="mini" header-cell-class-name="list_table_th text-center">
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div class="icon_wrap">
                                <!-- <i class="operation_edit" @click="edit(scope.row.id,6)" title="修改"></i> -->
                                <i class="operation_delete" @click="del(scope.row.id,6)" title="删除"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="客户来源" prop="name" show-overflow-tooltip></el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <div :class="scope.row.status==1?'setBaseBtnStatus':'setBaseBtnStatusProhibit'" @click="changeStatus(scope.row.id,6,scope.row.status)">{{scope.row.status_label}}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </section>
        <section>
            <div class="path">
                <span class="title">币种</span>
                <div class="">
                    <i class="el-icon-refresh" @click="getList(7,1)"></i>
                    <el-button type="danger" @click="centerDialogVisible=!centerDialogVisible;type=2;which=7;typeName='币种'" size="mini">新增</el-button>
                </div>
            </div>
            <div class="table_path">
                <el-table :data="currencyList" style="width: 100%" height="100%" size="mini" header-cell-class-name="list_table_th text-center">
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div class="icon_wrap">
                                <!-- <i class="operation_edit" @click="edit(scope.row.id,7)" title="修改"></i> -->
                                <i class="operation_delete" @click="del(scope.row.id,7)" title="删除"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="币种" prop="name" show-overflow-tooltip></el-table-column>
                    <el-table-column label="符号" prop="symbol" show-overflow-tooltip></el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <div :class="scope.row.status==1?'setBaseBtnStatus':'setBaseBtnStatusProhibit'" @click="changeStatus(scope.row.id,7,scope.row.status)">{{scope.row.status_label}}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </section>
        <section>
            <div class="path">
                <span class="title">付款方</span>
                <div class="">
                    <i class="el-icon-refresh" @click="getList(11,1)"></i>
                    <el-button type="danger" @click="centerDialogVisible=!centerDialogVisible;type=2;which=11;typeName='付款方名称'" size="mini">新增</el-button>
                </div>
            </div>
            <div class="table_path">
                <el-table :data="payer" style="width: 100%" height="100%" size="mini" header-cell-class-name="list_table_th text-center">
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div class="icon_wrap">
                                <!-- <i class="operation_edit" @click="edit(scope.row.id,11)" title="修改"></i> -->
                                <i class="operation_delete" @click="del(scope.row.id,11)" title="删除"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="付款方" prop="name" show-overflow-tooltip></el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <div :class="scope.row.status==1?'setBaseBtnStatus':'setBaseBtnStatusProhibit'" @click="changeStatus(scope.row.id,11,scope.row.status)">{{scope.row.status_label}}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </section>
        <section>
            <div class="path">
                <span class="title">加工厂</span>
                <div class="">
                    <i class="el-icon-refresh" @click="getList(8,1)"></i>
                    <el-button type="danger" @click="centerDialogVisible=!centerDialogVisible;type=2;which=8;typeName='加工厂'" size="mini">新增</el-button>
                </div>
            </div>
            <div class="table_path">
                <el-table :data="machList" style="width: 100%" height="100%" size="mini" header-cell-class-name="list_table_th text-center">
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div class="icon_wrap">
                                <!-- <i class="operation_edit" @click="edit(scope.row.id,8)" title="修改"></i> -->
                                <i class="operation_delete" @click="del(scope.row.id,8)" title="删除"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="加工厂" prop="name" show-overflow-tooltip></el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <div :class="scope.row.status==1?'setBaseBtnStatus':'setBaseBtnStatusProhibit'" @click="changeStatus(scope.row.id,8,scope.row.status)">{{scope.row.status_label}}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </section>
        <section>
            <div class="path">
                <span class="title">报关公司</span>
                <div class="">
                    <i class="el-icon-refresh" @click="getList(12,1)"></i>
                    <el-button type="danger" @click="centerDialogVisible=!centerDialogVisible;type=2;which=12;typeName='报关公司'" size="mini">新增</el-button>
                </div>
            </div>
            <div class="table_path">
                <el-table :data="brokersList" style="width: 100%" height="100%" size="mini" header-cell-class-name="list_table_th text-center">
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div class="icon_wrap">
                                <!-- <i class="operation_edit" @click="edit(scope.row.id,12)" title="修改"></i> -->
                                <i class="operation_delete" @click="del(scope.row.id,12)" title="删除"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="报关公司" prop="name" show-overflow-tooltip></el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <div :class="scope.row.status==1?'setBaseBtnStatus':'setBaseBtnStatusProhibit'" @click="changeStatus(scope.row.id,12,scope.row.status)">{{scope.row.status_label}}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </section>
        <section>
            <div class="path">
                <span class="title">货权单位</span>
                <div class="">
                    <i class="el-icon-refresh" @click="getList(9,1)"></i>
                    <el-button type="danger" @click="centerDialogVisible=!centerDialogVisible;type=2;which=9;typeName='货权单位'" size="mini">新增</el-button>
                </div>
            </div>
            <div class="table_path">
                <el-table :data="openingCompany" style="width: 100%" height="100%" size="mini" header-cell-class-name="list_table_th text-center">
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div class="icon_wrap">
                                <!-- <i class="operation_edit" @click="edit(scope.row.id,9)" title="修改"></i> -->
                                <i class="operation_delete" @click="del(scope.row.id,9)" title="删除"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="货权单位" prop="name" show-overflow-tooltip></el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <div :class="scope.row.status==1?'setBaseBtnStatus':'setBaseBtnStatusProhibit'" @click="changeStatus(scope.row.id,9,scope.row.status)">{{scope.row.status_label}}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </section>
        <el-dialog v-dialog-drag :title=" type == 2 ? '新增'+ typeName : '修改'+ typeName" :visible.sync="centerDialogVisible" width="400px"  class="eldialog no_print eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item v-if="which==3" label="费用类型：" prop="name" >
                        <el-select v-model="data.types" placeholder="费用类型">
                            <el-option v-for="list in feeName" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="which==10" label="仓库：" prop="name" >
                        <el-select v-model="data.warehouse_id" placeholder="仓库">
                            <el-option v-for="list in warehouseList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="typeName+'：'" prop="name" v-if="which!=7">
                        <el-input v-model="data.name" placeholder="请输入名称" :disabled="isEdit"></el-input>
                    </el-form-item>
                    <el-form-item v-if="which==7" label="币种名称：" prop="name" >
                        <el-select v-model="name_type" placeholder="币种名称" filterable @change="selectChange()">
                            <el-option v-for="list in currencyOptionsList"  :key="list.name" :value="'+'+list.name+':'+list.unit+'/'+list.symbol" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="which==7" label="币种简称：" prop="name" >
                        <el-input v-model="data.symbol" placeholder="币种简称" disabled></el-input>
                    </el-form-item>
                    <el-form-item v-if="which==7" label="币种符号：" prop="name" >
                        <el-input v-model="data.unit" placeholder="币种符号" disabled></el-input>
                    </el-form-item>
                    <el-form-item v-if="which==4" label="所属区域：" prop="name" >
                        <el-select v-model="data.area_id" placeholder="所属区域">
                            <el-option v-for="list in areaName" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <div class="tipStyle" v-if="which==4">新增仓库后，请同步授权用户仓库权限</div>
                <div class="tipStyle" v-if="which==7">如未找到其他币种，请联系客服添加</div>
                <el-button class="dialogBtn funcPublicBtn" @click="centerDialogVisible = false">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="add">确定</el-button>
            </div>
		</el-dialog>
    </div>
</template>
<style scoped lang="scss">
    .container{ min-width: 4800px;
        padding:20px; display: flex; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;
        & > section{
            display: flex; flex-direction: column;
            & + section{ margin-left: 60px; }
        }
        .path{
            margin-bottom: 7px; display: flex; align-items: center; justify-content: space-between;
            .title{
                font-size:16px; font-weight:bold; color: #333333; border-left:4px solid #155BD4; padding-left: 12px;
            }
        }
        .table_path{ flex: 1; box-shadow:0px 0px 10px rgba(94,94,94,0.16); border-radius:3px; width: 340px; padding: 8px 10px;overflow: hidden;  }

    }
    .el-icon-refresh{margin-right:10px;cursor: pointer;color:#F9A602;font-weight: 600;}
    .dialogBtnList{margin-top: 15px;}
    .tipStyle{margin-bottom:5px;}
</style>
<script>
    export default {
        data(){
            return{
                which:1,//1.港口 2.付款方式 3.费用名称 //4.仓库 //5.客户属性 //6.客户来源 //7.币种 //8.加工厂 //9.货权单位 //10.库位 //11.付款方 //12.报关公司
                type:2,//2.新增 3.修改
                typeName:"",
                data:{
                    name:"",
                    id:"",
                    types:"",
                    symbol:"",
                    warehouse_id:"",
                    area_id:"",
                },
                brandList:[],
                breedList:[],
                gradeList:[],
                warehouseList:[],
                attributeList:[],
                sourceList:[],
                feeName:[],
                areaName:[],
                currencyList:[],
                payer:[],
                machList:[],
                brokersList:[],
                openingCompany:[],
                location:[],
                centerDialogVisible:false,
                centerDialogVisibleB:false,
                currencyOptionsList:[],
                name_type:"",
                isEdit:false,
            }
        },
        created(){
            this.getList(1)
            this.getList(2)
            this.getList(3)
            this.getList(4)
            this.getList(5)
            this.getList(6)
            this.getList(7)
            this.getList(8)
            this.getList(9)
            this.getList(10)
            this.getList(11)
            this.getList(12)
            this.postFunc("erp/fee.type.category",{},res=>{
                this.feeName=res.data.data;
            },error=>{
                this.tip(error.data.message,"warning")
            })
            this.postFunc("erp/warehouse.area.select",{},res=>{
                this.areaName=res.data.data;
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        methods:{
            selectChange(){
                var s = this.name_type;
                var name = (s.substring(s.indexOf('+'),s.indexOf(':'))).split('+')[1];
                var unit = (s.substring(s.indexOf(':'),s.indexOf('/'))).split(':')[1];
                var symbol = s.substr(s.lastIndexOf("/") + 1);
                this.data.name = name;
                this.data.unit = unit;
                this.data.symbol = symbol;
            },
            changeStatus(id,type,status){
                let url="";
                this.which=type;
                if(type==1){
                    url="/erp/port.status";
                }else if(type==2){
                    url="/erp/payment.type.status";
                }else if(type==3){
                    url="/erp/fee.type.status";
                }else if(type==4){
                    url="/erp/warehouse.status";
                }else if(type==5){
                    url="/erp/customer.attribute.status";
                }else if(type==6){
                    url="/erp/customer.source.status";
                }else if(type==7){
                    url="/erp/currency.status";
                }else if(type==8){
                    url="/erp/plant.status";
                }else if(type==9){
                    url="/erp/opening.company.status";
                }else if(type==10){
                    url="/erp/warehouse.location.status";
                }else if(type==11){
                    url="/erp/payer.status";
                }else if(type==12){
                    url="/erp/custom.brokers.status";
                }
                if(status==1){
                    status=0
                }else{
                    status=1
                }
                this.postFunc(url,{id:id,status:status},()=>{
                    this.tip("修改成功","success")
                    this.getList(this.which)
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            edit(id,type){
                let list=null;
                this.type=3;
                this.which=type;
                if(type==1){
                    list=JSON.parse(JSON.stringify(this.brandList));
                    this.typeName="计量单位";
                }else if(type==2){
                    list=JSON.parse(JSON.stringify(this.breedList));
                    this.typeName="付款方式";
                }else if(type==3){
                    list=JSON.parse(JSON.stringify(this.gradeList));
                    this.typeName="费用名称";
                }else if(type==4){
                    list=JSON.parse(JSON.stringify(this.warehouseList));
                    this.typeName="仓库名称";
                    this.isEdit = true;
                }else if(type==5){
                    list=JSON.parse(JSON.stringify(this.attributeList));
                    this.typeName="客户属性";
                }else if(type==6){
                    list=JSON.parse(JSON.stringify(this.sourceList));
                    this.typeName="客户来源";
                }
                else if(type==7){
                    list=JSON.parse(JSON.stringify(this.currencyList));
                    this.postFunc('erp/currency.options',{},res=>{
                        this.currencyOptionsList = res.data.data;
                    })
                    // this.typeName="币种简称";
                }
                else if(type==8){
                    list=JSON.parse(JSON.stringify(this.machList));
                    this.typeName="加工厂";
                }else if(type==9){
                    list=JSON.parse(JSON.stringify(this.openingCompany));
                    this.typeName="货权单位";
                }else if(type==10){
                    list=JSON.parse(JSON.stringify(this.location));
                    this.typeName="库位";
                }else if(type==11){
                    list=JSON.parse(JSON.stringify(this.payer));
                    this.typeName="付款方";
                }else if(type==12){
                    list=JSON.parse(JSON.stringify(this.brokersList));
                    this.typeName="报关公司";
                }
                list.forEach(item=>{
                    if(item.id==id){
                        this.data=item;
                        this.name_type = item.name;
                    }
                })
                this.centerDialogVisible=true;
            },
            del(id,type){
                let url="";
                if(type==1){
                    url="/erp/port.delete";
                }else if(type==2){
                    url="/erp/payment.type.delete";
                }else if(type==3){
                    url="/erp/fee.type.delete";
                }else if(type==4){
                    url="/erp/warehouse.delete";
                }else if(type==5){
                    url="/erp/customer.attribute.delete";
                }else if(type==6){
                    url="/erp/customer.source.delete";
                }else if(type==7){
                    url="/erp/currency.delete";
                }else if(type==8){
                    url="/erp/plant.delete";
                }else if(type==9){
                    url="/erp/opening.company.delete";
                }else if(type==10){
                    url="/erp/warehouse.location.delete";
                }else if(type==11){
                    url="/erp/payer.delete";
                }else if(type==12){
                    url="/erp/custom.brokers.delete";
                }
                 this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    this.postFunc(url,{id:id},()=>{
                        this.getList(type)
                        this.tip("删除成功","success")
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            getList(type = 1,showMessage){
                let url="";
                if(type==1){
                    url="/erp/port.list";
                }else if(type==2){
                    url="/erp/payment.type.list";
                }else if(type==3){
                    url="/erp/fee.type.list";
                }else if(type==4){
                    url="/erp/warehouse.list";
                }else if(type==5){
                    url="/erp/customer.attribute.list";
                }else if(type==6){
                    url="/erp/customer.source.list";
                }else if(type==7){
                    url="/erp/currency.list";
                }else if(type==8){
                    url="/erp/plant.list";
                }else if(type==9){
                    url="/erp/opening.company.list";
                }else if(type==10){
                    url="/erp/warehouse.location.list";
                }else if(type==11){
                    url="/erp/payer.list";
                }else if(type==12){
                    url="/erp/custom.brokers.list";
                }
                this.postFunc(url,{},res=>{
                    if(type==1){
                        this.brandList=res.data.data;
                    }else if(type==2){
                        this.breedList=res.data.data;
                    }else if(type==3){
                        this.gradeList=res.data.data;
                    }else if(type==4){
                        this.warehouseList=res.data.data;
                    }else if(type==5){
                        this.attributeList=res.data.data;
                    }else if(type==6){
                        this.sourceList=res.data.data;
                    }else if(type==7){
                        this.currencyList=res.data.data;
                        this.postFunc('erp/currency.options',{},res=>{
                            this.currencyOptionsList = res.data.data;
                        })
                    }else if(type==8){
                        this.machList=res.data.data;
                    }else if(type==9){
                        this.openingCompany=res.data.data;
                    }else if(type==10){
                        this.location=res.data.data;
                    }else if(type==11){
                        this.payer=res.data.data
                    }else if(type==12){
                        this.brokersList=res.data.data;
                    }
                    if(showMessage){
                        this.tip("刷新成功","success")
                    }
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            add(){
                let url="";
                if(this.which==1&&this.type==2){
                    url="/erp/port.create";
                }else if(this.which==1&&this.type==3){
                    url="/erp/port.update";
                }else if(this.which==2&&this.type==2){
                    url="/erp/payment.type.create";
                }else if(this.which==2&&this.type==3){
                    url="/erp/payment.type.update";
                }else if(this.which==3&&this.type==2){
                    url="/erp/fee.type.create";
                }else if(this.which==3&&this.type==3){
                    url="/erp/fee.type.update";
                }else if(this.which==4&&this.type==2){
                    url="/erp/warehouse.create";
                }else if(this.which==4&&this.type==3){
                    url="/erp/warehouse.update";
                }else if(this.which==5&&this.type==2){
                    url="/erp/customer.attribute.create";
                }else if(this.which==5&&this.type==3){
                    url="/erp/customer.attribute.update";
                }else if(this.which==6&&this.type==2){
                    url="/erp/customer.source.create";
                }else if(this.which==6&&this.type==3){
                    url="/erp/customer.source.update";
                }else if(this.which==7&&this.type==2){
                    url="/erp/currency.create";
                }else if(this.which==7&&this.type==3){
                    url="/erp/currency.update";
                }else if(this.which==8&&this.type==2){
                    url="/erp/plant.create";
                }else if(this.which==8&&this.type==3){
                    url="/erp/plant.update";
                }else if(this.which==9&&this.type==2){
                    url="/erp/opening.company.create";
                }else if(this.which==9&&this.type==3){
                    url="/erp/opening.company.update";
                }else if(this.which==10&&this.type==2){
                    url="/erp/warehouse.location.create";
                }else if(this.which==10&&this.type==3){
                    url="/erp/warehouse.location.update";
                }else if(this.which==11&&this.type==2){
                    url="/erp/payer.create";
                }else if(this.which==11&&this.type==3){
                    url="/erp/payer.update";
                }else if(this.which==12&&this.type==2){
                    url="/erp/custom.brokers.create";
                }else if(this.which==12&this.type==3){
                    url="/erp/custom.brokers.update";
                }
                this.postFunc(url,this.data,()=>{
                    this.centerDialogVisible=false;
                    if(this.type==2){
                        this.tip("添加成功","success")
                    }else{
                        this.tip("修改成功","success")
                    }
                    this.getList(this.which)
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            }
        },
        watch:{
            centerDialogVisible:function(val){
                if(!val){
                    this.data = this.resetJson(this.data)
                    this.name_type  = '';
                    this.isEdit = false;
                }
            }
        }
    }
</script>
